import React from 'react';
import { Routes, Route } from "react-router-dom";
import Sidebar from './components/Sidebar';
import Dashboard from './pages/Dashboard';
import Reports from './pages/Reports';
import PageNotFound from './pages/PageNotFound';
import './App.css';
import DataVisualization from './pages/DataVisualization';
import Report from './pages/Report';
import Compliance from './pages/Compliance';
import EnvironmentalMonitoring from './pages/EnvironmentalMonitoring';
import EnvironmentalMonitoringProduct from './pages/EnvironmentalMonitoringProduct';
import SupplyChainTracking from './pages/SupplyChainTracking';
import SupplyChainTrackingResults from './pages/SupplyChainTrackingResults';
import ObservationResults from './pages/ObservationResults';
import Login from './pages/Login';
import ProtectedRoute from './pages/ProtectedRoute';
import Recommendations from './pages/Recommendations';
import AuthWatcher from './auth/AuthWatcher';


function App() {
	return (
		<>
			<AuthWatcher/>
			<Routes>
				<Route path="/login" element={<Login />} />
				<Route path="/" element={<ProtectedRoute />}>
					<Route element={<Sidebar />}>
						<Route index element={<Dashboard />} />
						<Route path="/data-visualization" element={<DataVisualization />} />
						<Route path="/reports" element={<Reports />} />
						<Route path="/report/:id" element={<Report />} />
						<Route path="/compliance" element={<Compliance />} />
						<Route path="/environmental-monitoring" element={<EnvironmentalMonitoring />} />
						<Route path="/environmental-monitoring-results/:datastreamID" element={<EnvironmentalMonitoringProduct />} />
						<Route path="/observation/:observationID" element={<ObservationResults />} />
						<Route path="/supply-chain-tracking" element={<SupplyChainTracking />} />
						<Route path="/supply-chain-tracking-results/:consortiumId/:lotNumber" element={<SupplyChainTrackingResults />} />
						<Route path="/recommendations" element={<Recommendations />} />
						<Route path="/*" element={<PageNotFound />} />
					</Route>
				</Route>
			</Routes>
		</>
	);
}

export default App;
